import hr from "date-fns/locale/hr";
import DatePicker, { registerLocale } from "react-datepicker";

import { Icon } from "src/app/components/icon/Icon";

import "./Datepicker.css";

registerLocale("hr", hr);
const Datepicker = ({
  startDate,
  endDate,
  handleChange,
}: {
  startDate: Date | undefined;
  endDate: Date | undefined;
  handleChange: (value: [Date | null, Date | null]) => void;
}) => {
  return (
    <DatePicker
      locale={"hr"}
      selected={startDate}
      onChange={handleChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      className="test"
      customInput={
        <div>
          <input value={`${startDate ? startDate.toLocaleDateString("hr") : ""}`} onChange={() => {}} />
          <div className="dateSeparation">do</div>
          <input value={`${endDate ? endDate.toLocaleDateString("hr") : ""}`} onChange={() => {}} />
          <Icon name="calendar" className="calendarIcon" />
        </div>
      }
    />
  );
};

export default Datepicker;
